import React from 'react';
import { Stack, Text, Link } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';
import { imageStyles, linkStyles } from '../../SelectedWidgets.styles';
import { fallbackBookCover } from 'features/Rooms/PersonalMeetingCorner/assets/images';

const BookInfo: React.FC<{ type: string; content: any }> = ({ type, content }) => {
    if (type !== 'book') return null;
    const { title, author, coverUrl, publishedDate, isbn, source, infoUrl } = content || {};
    if (!title && !author && !coverUrl && !isbn) return null;

    return (
        <Stack
            tokens={{ childrenGap: 16 }}
            horizontal
            horizontalAlign="center"
            styles={{ root: { width: '100%', backgroundColor: '#FFF6E7', padding: 40, borderRadius: 10 } }}
        >
            {!coverUrl && fallbackBookCover && (
                <Stack>
                    <img
                        src={fallbackBookCover}
                        alt={title || 'fallback book cover'}
                        style={{ width: 200, height: 250, borderRadius: 10, objectFit: 'cover' }}
                    />
                    <Text variant="small" style={{ fontSize: '10px', color: '#666', marginTop: 4, textAlign: 'center' }}>
                        {IvicosStrings.personalMeetingCornerStrings.book.fallbackBookCover.photoBy}{' '}
                        <Link
                            href="https://unsplash.com/@mediamodifier?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Mediamodifier
                        </Link>{' '}
                        {IvicosStrings.personalMeetingCornerStrings.book.fallbackBookCover.on}{' '}
                        <Link
                            href="https://unsplash.com/photos/white-box-on-white-table-kML003ksO_0?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Unsplash
                        </Link>
                    </Text>
                </Stack>
            )}
            {coverUrl && <img src={coverUrl} alt={title || 'book cover'} style={imageStyles} />}
            <Stack>
                {title && (
                    <Text variant="xLarge" style={{ fontWeight: 'bold', marginBottom: 10 }}>
                        {title}
                    </Text>
                )}
                <Stack verticalAlign="center" tokens={{ childrenGap: 8 }}>
                    {author && <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.book.author.replace('{authorName}', author)}</Text>}
                    {publishedDate && (
                        <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.book.published.replace('{publishedDate}', publishedDate)}</Text>
                    )}
                    {isbn && <Text variant="medium">{IvicosStrings.personalMeetingCornerStrings.book.isbn.replace('{isbnNumber}', isbn)}</Text>}
                    {source && (
                        <Text variant="medium">
                            {IvicosStrings.personalMeetingCornerStrings.book.source}
                            <Link style={linkStyles} href={infoUrl} target="_blank" rel="noopener noreferrer">
                                {IvicosStrings.personalMeetingCornerStrings.book.openLibrary}
                            </Link>
                        </Text>
                    )}
                </Stack>
            </Stack>
        </Stack>
    );
};

export default BookInfo;
